module.exports = __webpack_public_path__ + "assets/img/busy_12.e9ae9b0f.png";